/* React */
import React from "react";

/* Ionic */
import { IonGrid, IonRow, IonCol } from "@ionic/react";

/* Utils */
import { camelCaseToUppercase } from "src/utils/helper/string-transformation";

/* Stylesheet */
import styles from "./StatsSlide.module.scss";

/* Interface */
import { StatsProps } from "src/shared/interfaces/charts/Boxplot";

const StatsSlide: React.FC<{
  stats: StatsProps;
  color: string;
}> = ({ stats, color }) => {
  return (
    <IonGrid className={styles.stats_slide}>
      {Object.entries(stats).map(([key, value], index) => {
        return (
          <IonRow
            key={index}
            className={styles.row}
            style={{
              height: `calc(100% / ${
                Object.entries(stats).length
              })`,
              background:
                index % 2 === 0 ? "#ffffff" : undefined,
            }}
          >
            <IonCol
              className={`${styles.col} ${styles.key_col}`}
            >
              <div className={styles.key}>
                {camelCaseToUppercase(key)}
              </div>
            </IonCol>
            <IonCol
              className={`${styles.col} ${styles.value_col}`}
            >
              <div
                style={{ background: color }}
                className={styles.value}
              >
                <div className={styles.value}>{value}</div>
              </div>
            </IonCol>
          </IonRow>
        );
      })}
    </IonGrid>
  );
};

export default StatsSlide;
